"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function DailyEssentialsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="4112" className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="aspect-[3/4] w-full animate-pulse rounded-none bg-muted/50" />
            <div className="h-4 w-2/3 animate-pulse rounded-none bg-muted/50" />
            <div className="h-4 w-1/3 animate-pulse rounded-none bg-muted/50" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-destructive">Failed to load formulations.</div>;
  }
  if (!products || products.length === 0) {
    return <div className="text-muted-foreground">No products found.</div>;
  }
  return <div className="grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col gap-5">
          {}
          <div className="relative aspect-[3/4] w-full overflow-hidden rounded-none border border-border bg-white transition-colors duration-400 ease-out group-hover:border-foreground">
            <Link to={product.link} className="block h-full w-full p-8">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-contain transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center text-muted-foreground/50">
                  No Image
                </div>}
            </Link>

            {}
            <div className="absolute inset-x-4 bottom-4 translate-y-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
              <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="w-full rounded-none bg-primary text-primary-foreground shadow-none hover:bg-primary/90 h-10 font-sans text-xs uppercase tracking-widest" text="Quick Add" showQuantity={false} />
            </div>
          </div>

          {}
          <div className="flex flex-col items-start gap-1.5">
            <Link to={product.link} className="font-sans text-base font-bold tracking-tight text-foreground transition-colors hover:text-primary/80">
              {product.title}
            </Link>
            <div className="font-sans text-sm text-muted-foreground">
              {product.price !== undefined && `$${product.price.toFixed(2)}`}
            </div>
          </div>
        </div>)}
    </div>;
}
export default function TheDailyEssentials() {
  const wp_query_params = {
    per_page: 4,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="featured-australian-formulations" className="dark bg-background py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end md:mb-16">
          <div className="max-w-2xl">
            <h2 className="font-serif text-3xl font-medium text-foreground md:text-4xl lg:text-5xl">
              Featured Australian Formulations
            </h2>
            <p className="mt-4 font-sans text-muted-foreground md:text-lg">
              Pharmaceutical-grade skincare solutions developed and manufactured in Victoria, Australia.
            </p>
          </div>
          <Link to="/ProductsPage" className="group inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-foreground hover:text-primary/80">
            Explore All
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        {}
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }} postType="product">
          <DailyEssentialsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}